import React, { useEffect, useRef, useState } from "react";
import { validatorListIcons } from "../../utils/constants";
import ClipLoaderComponent from "../loader/ClipLoaderComponent";
import { formatNumber, getValidatorImg } from "../../utils/helper";

export default function DelegatorDataTable({
    filteredAndSorteddelegadators = [],
    isUndefined,
    setHasMore,
    hasMore,
    setIsLoadingMore,
    isLoadingMore,
    validatorName,
    status,
    handleDelegators,
}) {
    const tableDivRef = useRef(null); // Create a ref for the main table div

    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "ascending",
    }); // Sorting state

    const handleSort = (key) => {
        if (sortConfig.key === key) {
            // Toggle between ascending, descending, and reset (default state)
            if (sortConfig.direction === "ascending") {
                setSortConfig({ key, direction: "descending" });
            } else if (sortConfig.direction === "descending") {
                setSortConfig({ key: "", direction: "" }); // Reset to default state
            }
        } else {
            setSortConfig({ key, direction: "ascending" });
        }
    };

    const sortedValidators = React.useMemo(() => {
        const validData = Array.isArray(filteredAndSorteddelegadators)
            ? filteredAndSorteddelegadators
            : [];
        let sortableData = [...validData];

        if (sortConfig.key) {
            sortableData.sort((a, b) => {
                const aValue = a[sortConfig.key];
                const bValue = b[sortConfig.key];

                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [filteredAndSorteddelegadators, sortConfig]);

    const [page, setPage] = useState(1);
    const pageSize = 12;
    const [transactions, setTransactions] = useState([]);

    useEffect(() => {
        const newTransactions = sortedValidators?.slice(0, page * pageSize);
        if (JSON.stringify(transactions) !== JSON.stringify(newTransactions)) {
            setTransactions(newTransactions);
        }
    }, [sortedValidators, transactions, page, pageSize]);

    useEffect(() => {
        if (page > 1) {
            handleDelegators();
        }
    }, [page]);

    // const fetchTransactions = () => {
    //     const newTransactions = sortedValidators?.slice(
    //         (page - 1) * pageSize,
    //         page * pageSize,
    //     );

    //     if (page * pageSize > sortedValidators?.length) {
    //         setTransactions((prev) => [...prev, ...newTransactions]);
    //         setHasMore(false);
    //     } else {
    //         setTransactions((prev) => [...prev, ...newTransactions]);
    //     }
    // };

    const handleScroll = () => {
        const div = tableDivRef.current;

        if (div) {
            if (div.scrollHeight - 300 < div.scrollTop + div.clientHeight) {
                setIsLoadingMore(true);
            }
        }
    };

    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    useEffect(() => {
        const div = tableDivRef.current;
        if (div) {
            const debouncedScroll = debounce(handleScroll, 200);
            div.addEventListener("scroll", debouncedScroll);
        }

        return () => {
            if (div) {
                div.removeEventListener("scroll", debounce(handleScroll, 200));
            }
        };
    }, []);

    useEffect(() => {
        if (isLoadingMore && hasMore) {
            setTimeout(() => {
                setPage((prevPage) => prevPage + 1);
                setIsLoadingMore(false);
            }, 1000);
        }
    }, [isLoadingMore, hasMore]);

    const currentValidators = transactions;

    return (
        <>
            <div
                ref={tableDivRef}
                className="relative max-h-[798px] overflow-auto rounded-3xl border-[1.5px] border-primaryWhite/[0.03] bg-[#121212]"
            >
                <table className="w-full text-left">
                    <thead className="border-b border-primaryWhite/[0.04] bg-black/[0.31]">
                        <tr>
                            <th
                                scope="col"
                                className="px-9 py-9"
                                onClick={() => handleSort("name")}
                            >
                                <div className="inline-flex items-center justify-center min-w-[290px] gap-2 text-sm font-normal leading-4 text-white/[0.44] cursor-pointer whitespace-nowrap">
                                    Name
                                    <span className="w-3 h-3 *:w-full *:h-full">
                                        {validatorListIcons?.arrow}
                                    </span>
                                </div>
                            </th>
                            <th
                                scope="col"
                                className="px-9 py-9"
                                onClick={() => handleSort("id")}
                            >
                                <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] cursor-pointer">
                                    Wallet Address
                                    <span className="w-3 h-3 *:w-full *:h-full">
                                        {validatorListIcons?.arrow}
                                    </span>
                                </div>
                            </th>
                            <th
                                scope="col"
                                className="px-9 py-9"
                                onClick={() => handleSort("stake_value")}
                            >
                                <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-white/[0.44] cursor-pointer whitespace-nowrap">
                                    $VANRY Staked
                                    <span className="w-3 h-3 *:w-full *:h-full">
                                        {validatorListIcons?.arrow}
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isUndefined && (
                            <tr className="border-b border-white/[0.03]">
                                <td
                                    className="px-9 pt-6 pb-8"
                                    colSpan="7"
                                >
                                    <ClipLoaderComponent
                                        size={55}
                                        customClass="justify-center"
                                    />
                                </td>
                            </tr>
                        )}
                        {!isUndefined && currentValidators?.length === 0 && (
                            <tr className="border-b border-white/[0.03]">
                                <td
                                    className="px-9 py-12"
                                    colSpan="7"
                                >
                                    <div className="text-sm leading-4 font-normal whitespace-nowrap flex justify-center items-center gap-3">
                                        No Delegators Found
                                    </div>
                                </td>
                            </tr>
                        )}
                        {!isUndefined &&
                            currentValidators?.length > 0 &&
                            currentValidators.map((validator, index) => (
                                <tr
                                    key={validator?.id}
                                    className="border-b border-white/[0.03] hover:bg-[#1A1A1A80]"
                                >
                                    <td className="px-9 pt-6 pb-8">
                                        <div className="text-base leading-5 font-medium whitespace-nowrap flex items-center gap-3">
                                            <div className="flex items-center justify-center w-[54px] h-[54px] mr-1">
                                                <img
                                                    src={getValidatorImg(
                                                        validatorName,
                                                    )}
                                                    alt=""
                                                    className="object-cover"
                                                />
                                            </div>
                                            {validatorName}
                                            <div className="flex items-center justify-center">
                                                <div
                                                    className={`flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-xl h-9 max-w-fit ${status === "inactive"
                                                            ? "!text-dim/30 !bg-[#1A1A1A] cursor-not-allowed"
                                                            : ""
                                                        }`}
                                                >
                                                    {status !== "inactive" && (
                                                        <span className="w-[6px] h-[6px] rounded-full bg-white/10"></span>
                                                    )}
                                                    {status}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-9 pt-6 pb-8">
                                        <div className="flex items-center justify-center gap-2 text-sm font-normal leading-4 text-primaryWhite whitespace-nowrap">
                                            {validator?.id}
                                        </div>
                                    </td>
                                    <td className="px-9 pt-6 pb-8">
                                        <div className="flex items-center justify-center gap-2 text-base font-normal leading-4 text-tagcolor whitespace-nowrap">
                                            {formatNumber(
                                                validator?.stake_value,
                                            ) ?? 0}{" "}
                                            $VANRY
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        {isLoadingMore &&
                            hasMore &&
                            currentValidators?.length > 10 && (
                                <tr className="border-b border-white/[0.03]">
                                    <td
                                        className="px-9 py-9"
                                        colSpan="8"
                                    >
                                        <ClipLoaderComponent
                                            size={40}
                                            customClass={"justify-center"}
                                        />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
            {/* <div className="flex item-center justify-between *:h-10 mt-[30px]">
                <div className="flex items-center gap-3 px-[10px] py-[6px] rounded-[10px] bg-[#1A1A1A] text-sm leading-none font-normal text-white">
                    <span className="text-white/50">Row Per Page:</span>{" "}
                    {rowsPerPage}
                </div>
            </div> */}
        </>
    );
}
